import React, { useState, useEffect, useContext } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import ModalWrapper from '../../../components/Modals/ModalWrapper';
import FontSizes from '../../../constants/FontSizes';
import { MainColors } from '../../../constants/Colors';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import FormTextInput from '../../../components/FormTextInput';
import MainButton from '../../../components/Buttons/MainButton';
import { AuthContext } from '../../../context/AuthProvider';
import CustomSnackbar from '../../../components/CustomSnackbar';
import ValidationErrorMessage  from '../../../components/ValidationErrorMessage';
const PasswordModal = (props) => {
    const { changePassword } = useContext(AuthContext);
    const [errorMessage, setErrorMessage] = useState('')
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState();

    useEffect(() => {
        if (currentPassword && newPassword) {
            // must also check if the currentPassword typed in matches the stored current password
            setSaveButtonDisabled(false);
        } else {
            setSaveButtonDisabled(true);
        }
    }, [currentPassword, newPassword]);

    const onSaveNewPasswordHandler = async () => {
        setSaveButtonDisabled(true);
        const { success, message } = await changePassword(currentPassword, newPassword)

        if(success){
            setSnackbarMessage('New password was saved.');
            setSnackbarVisible(true);
            props?.onSavePasswordSuccess();
            // clear the fields after saving or when closing the modal
            setCurrentPassword(null);
            setNewPassword(null);
            setErrorMessage('')
        }else{
            setErrorMessage(message)
        }
        
        setSaveButtonDisabled(false);
    }

    const onSnackbarDismissedHandler = () => {
        setSnackbarVisible(false);   
    }

    return (
        <>
            <ModalWrapper visible={props.visible}
                onModalBackgroundPressed={props.onModalBackgroundPressed}>
                <View style={styles.container}>
                    <View style={styles.headerContainer}>
                        <Text style={styles.title}>My Password</Text>
                        <TouchableOpacity onPress={props.onCloseButtonPressed} accessibilityLabel='Close'>
                            <MaterialCommunityIcons name="close" size={16} color={MainColors.mediumGray} />
                        </TouchableOpacity>
                    </View>
                    <View style={styles.contentContainer}>
                        <FormTextInput
                                label="Current Password"
                                placeholder="Enter current password"
                                secureTextEntry={true}
                                accessibilityLabel="Current Password"
                                accessibilityHint="Enter current password here"
                                defaultValue={currentPassword}
                                onChangeText={(currentPassword) => setCurrentPassword(currentPassword)}
                                editable={true}
                            />
                        <FormTextInput
                            label="New Password"
                            placeholder="Enter new password"
                            secureTextEntry={true}
                            accessibilityLabel="New Password"
                            accessibilityHint="Enter new password here"
                            defaultValue={newPassword}
                            onChangeText={(newPassword) => setNewPassword(newPassword)}
                            editable={true}
                        />
                        <ValidationErrorMessage message={errorMessage}></ValidationErrorMessage>
                        <MainButton
                            style={{ backgroundColor: saveButtonDisabled ? MainColors.lightGray : MainColors.primary }}
                            text="Save Changes"
                            accessibilityLabel='Save New Password'
                            accessibilityHint='Press this button to save your new password'
                            disabled={saveButtonDisabled}
                            onPress={() => onSaveNewPasswordHandler()}
                        />
                    </View>
                </View>
            </ModalWrapper>
            <CustomSnackbar
                message={snackbarMessage}
                visible={snackbarVisible}
                onDismiss={onSnackbarDismissedHandler}
                actionLabel='DONE'
                actionOnPress={() => setSnackbarVisible(false)}
            />
        </>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
        width: '100%'
    },
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray,
        paddingBottom: 10
    },
    title: {
        fontSize: FontSizes.medium,
        fontWeight: '600',
        color: MainColors.darkGray,
        textAlign: 'center',
    },
    text: {
        color: MainColors.darkGray,
        fontSize: FontSizes.small,
        fontWeight: '600',
    },
    contentContainer: {
        marginTop: 15
    }
});

export default PasswordModal;